import React, { FC } from 'react';

import { EditTwoTone } from '@ant-design/icons';

import { Layout, Row, Table, theme, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { useNavigate } from 'react-router-dom';

import { NSKeys } from '@app/i18n';

import { useTableParams } from '@app/services/hooks/useTableParams';

import { useGetOrderImportsQuery } from '../../hooks';

import { BASE_COLUMNS_WIP } from './data/constants';

import { Container } from './styles';

export const List: FC = () => {
  const navigate = useNavigate();
  const orderImportsT = useTranslation(NSKeys.orderImports);
  const commonT = useTranslation(NSKeys.common);
  const { current, pageSize, setPagination } = useTableParams();
  const { data, isLoading } = useGetOrderImportsQuery({
    offset: (current - 1) * pageSize,
    limit: pageSize,
  });
  const { token } = theme.useToken();

  return (
    <>
      <Layout.Header>
        <Row justify="space-between" align="middle">
          <Typography.Title level={2} className="title" style={{ marginBottom: 0 }}>
            {orderImportsT.t('title')}
          </Typography.Title>
        </Row>
      </Layout.Header>

      <Container>
        <Table
          loading={isLoading}
          dataSource={data?.items}
          rowKey="uid"
          className="tableClassname"
          style={{ marginTop: 24 }}
          scroll={{ x: true }}
          pagination={{
            current: current,
            pageSize: pageSize,
            total: data?.total,
            showQuickJumper: true,
            showSizeChanger: true,
            position: ['bottomCenter'],
            onChange: (newPage, newSize) => {
              setPagination(newPage, newSize);
            },
            showTotal: (total, range) => `${range[0]}-${range[1]} ${commonT.t('paginationOf')} ${total}`,
          }}
          columns={[
            ...BASE_COLUMNS_WIP.map((el) => ({ ...el, title: orderImportsT.t(el.title as any) })),
            {
              fixed: 'right',
              key: 'action',
              align: 'center',
              width: 40,
              render: (_, cell) => {
                return cell?.$permissions?.view ? (
                  <EditTwoTone
                    twoToneColor={token?.colorPrimary}
                    onClick={() => {
                      navigate(`/dashboard/orderImports/${cell.uid}`);
                    }}
                  />
                ) : null;
              },
            },
          ]}
        />
      </Container>
    </>
  );
};
